import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core';

import { IconTypeEnum } from '@ui/shared/model';

import { ImmomioTooltipDirective } from '@immomio/ui/tooltip';
import {
  Elevation,
  ElevationType
} from '../../../directives/elevation/elevation.model';
import { ElevationDirective } from '../../../directives/elevation/elevation.directive';
import { buildBEMClassNamesByGivenBaseClassAndFlags } from '../../../utils/class-names';
import {
  BadgeBorderRadiusEnum,
  BadgeColorEnum,
  BadgeSizeEnum
} from './badge.enum';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImmomioTooltipDirective, ElevationDirective]
})
export class BadgeComponent {
  readonly tooltipText = input('');
  readonly borderColor = input('');
  readonly borderType = input('');
  readonly color = input(BadgeColorEnum.NEUTRAL);
  readonly size = input(BadgeSizeEnum.NORMAL);
  readonly borderWidth = input('');
  readonly borderRadius = input(BadgeBorderRadiusEnum.SMALL);

  readonly clickable = input(false);
  readonly elevation = input<ElevationType>(Elevation.ZERO);
  readonly withCloseButton = input(false);
  readonly uppercase = input(true);
  readonly fontBold = input(false);

  readonly icon = input<IconTypeEnum | null>(null);
  readonly allowOverflow = input(false);

  readonly clickEvent = output<MouseEvent>();
  readonly closeEvent = output<MouseEvent>();

  public baseClass = 'badge';

  public getClassName(): string {
    return buildBEMClassNamesByGivenBaseClassAndFlags(this.baseClass, {
      [`color-${this.color()}`]: !!this.color(),
      [`size-${this.size()}`]: !!this.size(),
      [`border-radius-${this.borderRadius()}`]: !!this.borderRadius(),
      [`border-color-${this.borderColor()}`]: !!this.borderColor(),
      [`border-style-${this.borderType()}`]: !!this.borderRadius(),
      [`border-width-${this.borderWidth()}`]: !!this.borderWidth(),
      clickable: this.clickable()
    });
  }

  public badgeClick(event: MouseEvent): void {
    if (this.clickable()) {
      this.clickEvent.emit(event);
    }
  }

  public closeButtonClick(event: MouseEvent): void {
    if (this.withCloseButton()) {
      this.closeEvent.emit(event);
    }
  }
}
